import { useField } from 'formik';
import React, { memo, useCallback } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

import { ILoyaltyBonusOperationFormValues, ILoyaltyBonusOperationReasonOption } from '../interfaces';

type OperationType = ILoyaltyBonusOperationFormValues['type'];
const { OperationType } = ILoyaltyBonusOperationReasonOption;

export const OperationTypeToggle = memo(() => {
  const [field] = useField<OperationType>('type');

  const onOperationTypeChange = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_: null | OperationType, e: React.ChangeEvent<any>) => field.onChange(e),
    [field],
  );

  return (
    <ToggleButtonGroup
      type="radio"
      name={field.name}
      value={field.value}
      onChange={onOperationTypeChange}
      className="mb-4 w-100">
      <ToggleButton value={OperationType.Accrual} variant="default">
        Начислить
      </ToggleButton>
      <ToggleButton value={OperationType.ChargeOff} variant="default">
        Списать
      </ToggleButton>
    </ToggleButtonGroup>
  );
});

OperationTypeToggle.displayName = 'OperationTypeToggle';
